import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledConfirmedAppointments = styled(StyledFlex)`
   max-width: 100%;
   padding: 22px 0;
`;
StyledConfirmedAppointments.displayName = 'StyledConfirmedAppointments';
